document.addEventListener("DOMContentLoaded", function () {
  const variantId = '50911708119204';
  const sellingPlanId = '12512755876';
  const discountCode = 'THCASAMPLE';

  const observer = new MutationObserver((mutations, obs) => {
    const desktopForm = document.querySelector('form[data-testid^="klaviyo-form"]');
    const desktopButton = desktopForm?.querySelector('button[type="button"]');
    const desktopEmail = desktopForm?.querySelector('input[type="text"][autocomplete="email"]');

    const mobileForm = document.querySelector('.klaviyo-form-Ypd63u form');
    const mobileButton = mobileForm?.querySelector('button[type="button"]');
    const mobileEmail = mobileForm?.querySelector('input[type="text"][autocomplete="email"]');

    const attachListener = (form, button, emailInput) => {
      if (!form || !emailInput || !button) return;
      if (button.dataset.listenerAttached === "true") return;
      button.dataset.listenerAttached = "true";

      form.addEventListener("submit", (event) => {
        event.preventDefault(); 
        setTimeout(() => {
          const email = emailInput.value;
          if (email && email.includes('@')) {
            fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({
                id: variantId,
                quantity: 1
              })
            })
            .then(response => {
              console.log(response);
              if (response.ok) {
                window.location.href = `/checkout?checkout[email]=${encodeURIComponent(email)}&discount=${discountCode}`;
              } else {
                console.log(response, response.ok);
                alert("Failed to add product to cart.");
              }
            })
            .catch(err => console.error("Fetch error:", err));
          }
        }, 100);
      });
    };

    if (desktopForm && desktopButton && desktopEmail) {
      attachListener(desktopForm, desktopButton, desktopEmail);
    }

    if (mobileForm && mobileButton && mobileEmail) {
      attachListener(mobileForm, mobileButton, mobileEmail);
    }

    if ((desktopForm && desktopButton && desktopEmail) || 
        (mobileForm && mobileButton && mobileEmail)) {
      obs.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

